import React, { createContext, useState, ReactNode, FC, useEffect } from 'react';
import { User } from '../types';
import TokenExpiredModal from '../pages/components/TokenExpiredModal';
import { setTokenExpiredHandler } from '../utils/customFetch';

interface AppContextType {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  user: User | null;
  setUser: (user: User) => void;
  token: string | null;
  setToken: (token: string) => void;
}

export const AppContext = createContext<AppContextType>({
  currentStep: 0,
  setCurrentStep: () => {},
  user: null,
  setUser: () => {},
  token: null,
  setToken: () => {},
});

export const AppProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [user, setUser] = useState<User | null>(null);
  const [token, setToken] = useState<string | null>(null);
  const [tokenExpired, setTokenExpired] = useState(false);

  useEffect(() => {
    setTokenExpiredHandler(() => setTokenExpired(true));
  }, []);

  const handleCloseTokenExpired = () => {
    setTokenExpired(false);
    const url = `${process.env.GATSBY_WA_ME_BASE_URL}?text=Hola%2C%20necesito%20una%20nueva%20sesi%C3%B3n%20para%20continuar%20con%20la%20transferencia`;
    window.location.href = url;
  }

  return (
    <AppContext.Provider
      value={{ currentStep, setCurrentStep, user, setUser, token, setToken }}
    >
      {children}
      <TokenExpiredModal open={tokenExpired} onClose={handleCloseTokenExpired} />
    </AppContext.Provider>
  );
};
